import { PlatformAbilitiesContext } from 'app/providers/PlatformAbilitiesProvider';
import { useContext } from 'react';

export const usePlatformAbilities = () => {
  const context = useContext(PlatformAbilitiesContext);

  return context;
};
